import { render } from "./PriceFactorStatement.vue?vue&type=template&id=729758db&scoped=true"
import script from "./PriceFactorStatement.vue?vue&type=script&lang=js"
export * from "./PriceFactorStatement.vue?vue&type=script&lang=js"

import "./PriceFactorStatement.vue?vue&type=style&index=0&id=729758db&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729758db"]])

export default __exports__